/**
 * グラフデータ取得API
 */
import { apiPost } from './client';

/**
 * グラフデータを取得
 * @param {Object} params - リクエストパラメータ
 * @param {string} params.place - 場所
 * @param {string} params.action - アクション
 * @param {number} params.year - 年
 * @param {number} params.month - 月
 * @param {AbortSignal} signal - キャンセル用のシグナル
 * @returns {Promise<Object>} グラフデータ
 */
export async function getGraph(params, signal) {
  return apiPost('/api/get-graph', params, { signal });
}
